module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', {
    staticClass: "sk-chasing-dots"
  }, [_c('div', {
    staticClass: "sk-child sk-dot1"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-child sk-dot2"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a915b516!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Spinner.vue
// module id = 1376
// module chunks = 1